(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-pfr-section]';

  function eachNode(scope, selector, callback) {
    if (!scope) return;
    if (scope.matches && scope.matches(selector)) callback(scope);
    if (!scope.querySelectorAll) return;
    Array.prototype.forEach.call(scope.querySelectorAll(selector), callback);
  }

  function setVideoButton(button, playing) {
    if (!button) return;
    var label = playing ? 'Pause motion' : 'Play motion';
    button.setAttribute('aria-label', label);
    var text = button.querySelector('[data-pfr-video-label]');
    if (text) text.textContent = label;
  }

  function initVideo(wrap, cleanups) {
    var video = wrap.querySelector('[data-pfr-video]');
    var button = wrap.querySelector('[data-pfr-video-toggle]');
    if (!video || !video.dataset.src) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var hydrated = false;
    var inView = false;
    var userPaused = false;
    var resumeAfterVisibility = false;
    var hydrationObserver;
    var playbackObserver;

    if (button) {
      button.tabIndex = -1;
      button.setAttribute('aria-hidden', 'true');
    }

    function safePlay() {
      if (reducedMotion.matches || userPaused || !inView || document.hidden) return;
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          setVideoButton(button, false);
        });
      }
    }

    function hydrate() {
      if (hydrated) return;
      hydrated = true;
      video.src = video.dataset.src;
      video.load();
    }

    function markReady() {
      wrap.classList.add('is-video-ready');
      if (button) {
        button.tabIndex = 0;
        button.removeAttribute('aria-hidden');
      }
      setVideoButton(button, !video.paused);
      safePlay();
    }

    function showFallback() {
      wrap.classList.remove('is-video-ready');
      wrap.classList.add('is-video-error');
      if (button) {
        button.tabIndex = -1;
        button.setAttribute('aria-hidden', 'true');
      }
    }

    function togglePlayback() {
      hydrate();
      if (video.paused) {
        userPaused = false;
        inView = true;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            setVideoButton(button, false);
          });
        }
      } else {
        userPaused = true;
        video.pause();
      }
    }

    function handleVisibility() {
      if (document.hidden) {
        resumeAfterVisibility = !video.paused;
        video.pause();
      } else if (resumeAfterVisibility) {
        resumeAfterVisibility = false;
        safePlay();
      }
    }

    function handleMotionPreference() {
      if (reducedMotion.matches) {
        video.pause();
      } else {
        safePlay();
      }
    }

    video.addEventListener('loadeddata', markReady);
    video.addEventListener('playing', function () {
      setVideoButton(button, true);
    });
    video.addEventListener('pause', function () {
      setVideoButton(button, false);
    });
    video.addEventListener('error', showFallback);
    if (button) button.addEventListener('click', togglePlayback);
    document.addEventListener('visibilitychange', handleVisibility);

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', handleMotionPreference);
    } else if (reducedMotion.addListener) {
      reducedMotion.addListener(handleMotionPreference);
    }

    if ('IntersectionObserver' in window) {
      hydrationObserver = new IntersectionObserver(
        function (entries) {
          if (entries[0] && entries[0].isIntersecting) {
            hydrate();
            hydrationObserver.disconnect();
          }
        },
        { rootMargin: '300px 0px', threshold: 0 }
      );
      hydrationObserver.observe(wrap);

      playbackObserver = new IntersectionObserver(
        function (entries) {
          if (!entries[0]) return;
          inView = entries[0].isIntersecting;
          if (inView) {
            hydrate();
            safePlay();
          } else {
            video.pause();
          }
        },
        { threshold: 0.25 }
      );
      playbackObserver.observe(wrap);
    } else {
      inView = true;
      hydrate();
    }

    cleanups.push(function () {
      if (hydrationObserver) hydrationObserver.disconnect();
      if (playbackObserver) playbackObserver.disconnect();
      document.removeEventListener('visibilitychange', handleVisibility);
      if (button) button.removeEventListener('click', togglePlayback);
      if (reducedMotion.removeEventListener) {
        reducedMotion.removeEventListener('change', handleMotionPreference);
      } else if (reducedMotion.removeListener) {
        reducedMotion.removeListener(handleMotionPreference);
      }
      video.pause();
      video.removeAttribute('src');
      video.load();
    });
  }

  function initSection(root) {
    if (!root || root.dataset.pfrInitialized === 'true') return;
    root.dataset.pfrInitialized = 'true';
    var cleanups = [];

    eachNode(root, '[data-pfr-video-wrap]', function (wrap) {
      initVideo(wrap, cleanups);
    });

    root.pfrDestroy = function () {
      cleanups.forEach(function (cleanup) {
        cleanup();
      });
      delete root.dataset.pfrInitialized;
      delete root.pfrDestroy;
    };
  }

  function initWithin(scope) {
    eachNode(scope, SECTION_SELECTOR, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWithin(document);
    });
  } else {
    initWithin(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWithin(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    eachNode(event.target, SECTION_SELECTOR, function (root) {
      if (typeof root.pfrDestroy === 'function') root.pfrDestroy();
    });
  });
})();
